import { ActivityConfigItemType } from './activity-config-item-type.enum';
import { JsonObject, JsonProperty } from 'json2typescript';


@JsonObject
export class ActivityDefaultLearnCertConfigItem {
  @JsonProperty('activityType', String)
  activityType: ActivityConfigItemType = undefined;

  /**
   * null æ å­¦åï¼ false æå¨æäºï¼ true èªå¨æäº
   */
  @JsonProperty('autoGranted', Object)
  autoGranted: boolean = undefined;

  @JsonProperty('learnCertId', Object)
  learnCertId: number = undefined;

  constructor(activityType?: ActivityConfigItemType, autoGranted?: boolean, learnCertId?: number) {
    this.activityType = activityType;
    this.autoGranted = autoGranted;
    this.learnCertId = learnCertId;
  }
}
